import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import GenericLoadError from '../../../common/GenericLoadError'
import useAlert from '../../../hooks/useAlert'
import { authedAxios } from '../../../utils'

const ActivityModal = ({ isOpen, onClose, onSave, customerContactId }) => {
  const [date, setDate] = useState(new Date().toLocaleDateString('sv'))
  const [activityTypeId, setActivityTypeId] = useState(null)
  const [types, setTypes] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  const { createAlert, createGenericErrorAlert } = useAlert()

  const handleSave = () => {
    authedAxios
      .post('/api/activity', {
        activityTypeId,
        date,
        customerContactId,
      })
      .then(() => {
        onSave()
        createAlert({ message: 'Activity recorded' })
      })
      .catch(() => {
        createGenericErrorAlert()
      })
  }

  const getActivityTypes = () => {
    return authedAxios
      .get('/api/activity/types')
      .then((res) => {
        setTypes(res.data.activityTypes)
        setActivityTypeId(res.data.activityTypes[0].id)
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
        setError(true)
      })
  }

  useEffect(() => {
    getActivityTypes()
  }, [])

  const filteredTypes = types.filter((t) => t.isManualAdd)

  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth={'sm'}>
      <DialogTitle>Log an activity</DialogTitle>

      <DialogContent>
        {loading && <CircularProgress />}
        {error && <GenericLoadError />}
        {!error && !loading && (
          <>
            <TextField
              fullWidth
              label={'Activity type'}
              onChange={(e) => setActivityTypeId(e.target.value)}
              margin={'dense'}
              value={activityTypeId}
              select
            >
              {filteredTypes.map((t) => (
                <MenuItem key={t.id} value={t.id}>
                  {t.name}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              fullWidth
              label={'Date'}
              type={'date'}
              onChange={(e) => setDate(e.target.value)}
              margin={'dense'}
              value={date}
            />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant={'contained'}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ActivityModal
